import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";

const taskDefinition = {
  state: { editedTask: undefined, tasks: [] },
  getters: { editedTask: (state) => state.editedTask, tasks: (state) => state.tasks },
  mutations: {
    tasks: (state, value) => (state.tasks = value ?? []),
    editedTask: (state, value) => (state.editedTask = value),

    addTaskItem: (state, { task }) => {
      if (!task._id) {
        task._id = "id" + new Date().getTime(); //id atama
      }

      state.tasks = [...state.tasks, { ...task }];
    },
    updateTaskItem: (state, { task }) => {
      state.tasks = state.tasks.map((t) => {
        if (t._id == task._id) {
          t = task;
        }
        t.taskRelations = t.taskRelations?.map((link) => {
          if (link.task._id == task._id) {
            return { linkType: link.linkType, task };
          }
          return link;
        });

        return t;
      });
    },

    removeTaskItem: (state, { task }) => {
      state.tasks = [...state.tasks.filter((t) => t._id != task._id)];
    },
    reset: (state, value) => {
      state.editedTask = undefined;
      state.tasks = [];
    },
  },
  actions: {},
};

export const managementSystemFlow = createCrudVuexModule({
  namespaced: true,
  path: "/management/flow-rule",

  state: { ...taskDefinition.state },
  getters: { ...taskDefinition.getters },
  mutations: { ...taskDefinition.mutations },

  actions: {
    ...taskDefinition.actions,
    async create({ getters, commit, dispatch }, payload) {
      try {
        commit("isUpdating", true);
        payload = await dispatch("preparePayload", {
          editedEntity: getters.editedEntity,
          form: payload,
        });

        const response = await rest.post("/management/flow-rule", { item: payload });
        commit("editedEntity", undefined);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },

    async update({ getters, commit, dispatch }, payload) {
      try {
        commit("isUpdating", true);
        payload = await dispatch("preparePayload", {
          editedEntity: getters.editedEntity,
          form: payload,
        });

        const response = await rest.put("/management/flow-rule", { item: payload });

        commit("editedEntity", undefined);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
  },
});
